export const loadingIndicator = {
  SHOW_LOADING_INDICATOR: 'loadingIndicator/show-loading-indicator'
};

// gpt
export const gpt = {
  FETCH_GPT_REQUEST: 'FETCH_GPT_REQUEST',
  FETCH_GPT_LOADING: 'FETCH_GPT_LOADING',
  FETCH_GPT_SUCCESS: 'FETCH_GPT_SUCCESS',
  FETCH_GPT_FAILURE: 'FETCH_GPT_FAILURE'
};

export const mpesaTransaction = {
  POST_MPESA_TRANSACTION_REQUEST:
		'generate-stk-push/post-generate-stk-push-request',
  POST_MPESA_TRANSACTION_SUCCESS:
		'generate-stk-push/post-generate-stk-push-success',
  POST_MPESA_TRANSACTION_FAILURE:
		'generate-stk-push/post-generate-stk-push-failure'
};
export const subscription = {
  SUBSCRIBE_TO_NEWSLETTER: 'subscription/subscribe-to-newsletter'
};
